import React  from 'react'
import DropDown from '../dropdown';
import { AllocationAndStrategy } from '../../../api/services/next'
import { useMemo } from 'react';

// HS-70186: `api` lets callers opt into an alternate endpoint (e.g. the grid flow's
// Monthly.GetMonthlyAllocations) with the same request/response shape. Defaults to the
// legacy AllocationAndStrategy.GetAllocationWithDates so every existing caller is unaffected.
const AllocationsWithDatesDropDown = ({ api = AllocationAndStrategy.GetAllocationWithDates, ...rest }) => {
    const spec = useMemo(() => ({
        IsActive: true,
    }), [] )
    return <DropDown api={api} spec={spec} textField="AllocationName" valueField="AllocationId"  {...rest}/>
}

export default AllocationsWithDatesDropDown

